import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'

interface AccountVerificationResendCodeTooltipProps {
  active: boolean
  hours?: string
  minutes?: string
}

const AccountVerificationResendCodeTooltip: React.FC<
  AccountVerificationResendCodeTooltipProps
> = ({ active, hours, minutes }): React.ReactElement => {
  const hourText = hours === '1' ? 'hour' : 'hours'
  const minuteText = minutes === '1' ? 'minute' : 'minutes'
  return active ? (
    <Tooltip openLeft={false}>
      <p>
        <Trns
          source={
            'In order to avoid confusing overlap and unnecessary charges to your card, we’ve placed a 24-hour limit on how often you can send a new code. You can send a new code in ${hours} and ${minutes}.'
          }
          expressions={{
            hours: `${hours} ${hourText}`,
            minutes: `${minutes} ${minuteText}`,
          }}
        />
      </p>
    </Tooltip>
  ) : (
    <Tooltip openLeft={false}>
      <p>
        <Trns
          source={
            'This will make a new, temporary charge, with the code in the description. In order to avoid confusing and unnecessary charges to your card, sending a code is only available once every 24 hours.'
          }
        />
      </p>
    </Tooltip>
  )
}

export default AccountVerificationResendCodeTooltip
